import { Navigate, type RouteObject } from "react-router-dom";

import { RequireAcceptInvite } from "@/components/shared/RequireAcceptInvite";
import { RequireAuth } from "@/components/shared/RequireAuth";
import { RequireMemberDisabled } from "@/components/shared/RequireMemberDisabled";
import { RequireNoOrgAccess } from "@/components/shared/RequireNoOrgAccess";
import { RequireSession } from "@/components/shared/RequireSession";
import {
  AccessLocked,
  AcceptInvite,
  Billing,
  MemberDisabled,
  NoOrgAccess,
  Onboarding,
  ProjectLegacyRedirect,
} from "@/router/lazyPages/standalone";
import { fullscreenSuspense } from "@/router/helpers";

export const standaloneRoutes: RouteObject[] = [
  {
    path: "/onboarding",
    element: <RequireSession>{fullscreenSuspense(<Onboarding />)}</RequireSession>,
  },
  {
    path: "/no-org-access",
    element: <RequireNoOrgAccess>{fullscreenSuspense(<NoOrgAccess />)}</RequireNoOrgAccess>,
  },
  {
    path: "/no-permission",
    element: <Navigate to="/home" replace />,
  },
  {
    path: "/member-disabled",
    element: (
      <RequireMemberDisabled>{fullscreenSuspense(<MemberDisabled />)}</RequireMemberDisabled>
    ),
  },
  {
    path: "/accept-invite",
    element: <RequireAcceptInvite>{fullscreenSuspense(<AcceptInvite />)}</RequireAcceptInvite>,
  },
  {
    path: "/access-locked",
    element: <RequireAuth>{fullscreenSuspense(<AccessLocked />)}</RequireAuth>,
  },
  {
    path: "/project/:projectId",
    element: <RequireAuth>{fullscreenSuspense(<ProjectLegacyRedirect />)}</RequireAuth>,
  },
  {
    path: "/billing",
    element: <RequireAuth>{fullscreenSuspense(<Billing />)}</RequireAuth>,
  },
];
